import styled from 'styled-components'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from 'components/Link'
import theme from 'styles/theme'

export const WrapperLink = styled(Link)`
  border: 0;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  ${theme.mediaQueries.medium} {
    max-width: 340px;
  }
`

export const CardImg = styled(GatsbyImage)`
  aspect-ratio: 10 / 16;
  @supports not (aspect-ratio: 10 / 16) {
    ${(props) => `height: ${props.width * 1.6}px;`}
  }
  max-height: 540px;

  img {
    opacity: 0.65 !important;
  }
`

const cardMetaStyle = `
  position: relative;
  padding-top: ${theme.space[1]};
  overflow-wrap: break-word;
  white-space: normal;

  html[dir='ltr'] {
    padding-right: ${theme.space[2]};
  }

  html[dir='rtl'] {
    padding-left: ${theme.space[2]};
  }
`

export const CardMeta = styled.div`
  ${cardMetaStyle}
`

export const CardMetaDivider = styled.span`
  display: inline-block;
  margin: 0 ${theme.space[1]};
  color: ${theme.colors.white};
`

export const CardTitle = styled.div`
  color: ${theme.colors.white};
`

export const CardEyebrow = styled.div`
  color: ${theme.colors.white};
`
